import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomSelect from "../../component/CustomSelect";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const addBlogEndpoint = ApiEndpoints.adminBlogs.blogCreate;
const authorListEndpoint = ApiEndpoints.autor.authorList;
const categoryListEndpoint = ApiEndpoints.category.categoryList;
const tagListEndpoint = ApiEndpoints.tags.tagList;

export default function AddBlogAdmin() {
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [tags, setTags] = useState([]);

  const [sections, setSections] = useState([
    { heading: "", description: "" },
    { heading: "", description: "" },
  ]);

  const [previews, setPreviews] = useState({ thumbnail: null, banner_image: null, });

  const [postData, setPostData] = useState({ title: "", slug: "", category_id: "", author_id: "",  date: "", brief: "", introduction: "", reference: "", thumbnail: null, alt_thumbnail: "", banner_image: null, alt_banner_image: "",  });


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await ApiRequest("GET", categoryListEndpoint);
        setCategories(response?.blog_categories || []);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        setCategories([]);
      }
    };

    const fetchAuthors = async () => {
      try {
        const response = await ApiRequest("GET", authorListEndpoint);
        setAuthors(response?.authors || []);
      } catch (error) {
        console.error("Failed to fetch authors:", error);
        setAuthors([]);
      }
    };

    const fetchTags = async () => {
      try {
        const response = await ApiRequest("GET", tagListEndpoint);
        setTags(response?.tags || []);
      } catch (error) {
        console.error("Failed to fetch tags:", error);
        setTags([]);
      }
    };

    fetchCategories();
    fetchAuthors();
    fetchTags();
  }, []);


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      const file = files[0];

      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const handleEditorChange = (key, data) => {
    setPostData((prev) => ({
      ...prev,
      [key]: data,
    }));
  };


  // ================= add more heading =================
  const handleSectionChange = (index, field, value) => {
    const updated = [...sections];
    updated[index][field] = value;
    setSections(updated);
  };

  const addImageBlock = () => {
    setSections([...sections, { heading: "", description: "" }]);
  };

  const removeImageBlock = (index) => {
    const updated = sections.filter((_, i) => i !== index);
    setSections(updated);
  };


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    // ===== basic validation =====
    // for (const [key, value] of Object.entries(postData)) {
    //   if (key !== "" && (value === "" || value === null)) {
    //     toast.error(`The field "${key}" is mandatory.`);
    //     return;
    //   }
    // }

    for (const [key, value] of Object.entries(postData)) {
      if (["reference"].includes(key)) continue;
      if (value === "" || value === null) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }



    // ===== add more validation
    for (let i = 0; i < sections.length; i++) {
      const { heading, description } = sections[i];

      if (i < 2) {
        if (!heading || !description) {
          toast.error(`Heading and Description ${i + 1} are mandatory.`);
          return;
        }
      }

      if (i >= 2) {
        if ((heading && !description) || (!heading && description)) {
          toast.error(
            `Heading and Description ${i + 1} are mandatory.`
          );
          return;
        }
      }

      if (!heading || !description) {
        toast.error(`Heading and Description ${i + 1} are mandatory.`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    formData.append("full_description", JSON.stringify(sections));

    try {
      const response = await ApiRequest(
        "POST",
        addBlogEndpoint,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.success(response.message);
      navigate("/blog");
    } catch (error) {
      console.error(error);
    }
  };


  const pagename = {
    name: 'Blog Management',
    user: 'Admin',
    innerpage: 'Blog Management / Blog / Add Blog'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="blogAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>category<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"category_id"} options={categories} placeholder="Select Category" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Name<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="author_id" options={authors} placeholder="Select Author Name" />
                </div>
              </div>

              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Tags (Comma Separated)<small></small></label>
                  </div>
                  <input onChange={handleChange} name="tags" type="text" className="form-control" placeholder="Enter Tags" />
                </div>
              </div> */}

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="date" type="date" className="form-control" placeholder="Enter Author Name" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Brief Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="brief" type="text" className="form-control" placeholder="Enter Brief" />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Introduction<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.introduction} onChange={(event, editor) => handleEditorChange("introduction", editor?.getData())} />
                </div>
              </div>
            </div>
          </div>


          <div className="add-content-wrap">
            <div className="row">
              {sections.map((section, index) => (
                <div className="col-lg-6" key={index}>
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Heading {index + 1} {index < 2 && <small>*</small>}</label>
                    </div>
                    <input type="text" className="form-control" placeholder="Enter Heading" value={section.heading} onChange={(e) => handleSectionChange(index, "heading", e.target.value)} />
                  </div>

                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Description {index + 1} {index < 2 && <small>*</small>}</label>
                    </div>
                    <DynamicCKEditor data={section.description} onChange={(event, editor) => handleSectionChange(index, "description", editor?.getData())} />
                  </div>

                  {sections.length > 2 && (
                    <button type="button" className="btn btn-sm btn-danger" onClick={() => removeImageBlock(index)}>Remove</button>
                  )}
                </div>
              ))}

              <div className="col-lg-12 add-page-inputs">
                <button type="button" className="addmore-images w-100" onClick={addImageBlock}>
                  Add More +
                </button>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Reference<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.reference} onChange={(event, editor) => handleEditorChange("reference", editor?.getData())} />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Thumbnail Image (468 × 329)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="thumbnail"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    requiredWidth={468}
                    requiredHeight={329}
                    imagePreview={previews.thumbnail} />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Thumbnail Image Alt Tag<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_thumbnail" type="text" className="form-control" placeholder="Alt Tag" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Banner Image (1608 × 640)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="banner_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    requiredWidth={1608}
                    requiredHeight={640}
                    imagePreview={previews.banner_image}
                  />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Banner Image Alt Tag<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_banner_image" type="text" className="form-control" placeholder="Alt Tag" />
                </div>
              </div>
                {/* 
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Image 1 (1080 × 560)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="image1"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    requiredWidth={1080}
                    requiredHeight={560}
                    imagePreview={previews.image1}
                  />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Image 1 Alt Tag<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_image1" type="text" className="form-control" placeholder="Alt Tag" />
                </div>
              </div> */}
            </div>
          </div>
        </form>
        <button type="submit" form="blogAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
